import React, {ForwardedRef} from "react";
import Row from "@Containers/components/Row";
import Column from "@Containers/components/Column";
import useAvatarSection from "@MyProfile/features/avatar/hooks/useAvatarSection";
import MyProfileAvatarDescription from "@MyProfile/features/avatar/components/MyProfileAvatarDescription";
import useIsMobile from "@Hooks/selector/useIsMobile";
import MobileAppTitle from "@SearchResults/components/HeadingContent/Mobile/MobileAppTitle";
import IconUserOutlineWithTrademark from "@Icons/user/IconUserOutlineWithTrademark";

interface MyProfileAvatarSectionProps {
    avatarRef: ForwardedRef<null>
}

function MyProfileAvatarSection({avatarRef}: MyProfileAvatarSectionProps) {
    const {
        realName,
        username,
        showMoreButton,
        setFiltersTrue,
        descriptionText,
    } = useAvatarSection()

    const isMobile = useIsMobile()

    if (isMobile) {
        return (
            <MobileAppTitle
                titleRef={avatarRef}
                sticky
            >
                <Column className="user-data">
                    <div>{`Hi ${realName}`}</div>
                    <small>{descriptionText()}</small>
                </Column>
            </MobileAppTitle>
        );
    }

    return (
        <div className="trvl--my-profile__avatar-section" ref={avatarRef}>
            <Column className="trvl--my-profile__avatar-content gb--emphasize-default">
                <Row className="basic-info">
                    <IconUserOutlineWithTrademark
                        width="40"
                        height="40"
                        style={{verticalAlign: "middle", transform: `scale(-1, 1)`}}
                    />
                    <Column className="user-data">
                        <h2 className="user-data-username">{realName}</h2>
                        <div>{username}</div>
                    </Column>
                </Row>
                <Row>
                    <MyProfileAvatarDescription
                        showMoreButton={showMoreButton}
                        descriptionText={descriptionText()}
                        setFiltersTrue={setFiltersTrue}
                    />
                </Row>
            </Column>
        </div>
    );
}

export default MyProfileAvatarSection